module.exports = __webpack_public_path__ + "img/step4.20adf395.png";